var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_454_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5002 7.2915C26.7752 7.2915 5.8335 25.6082 5.8335 48.1248C5.8335 70.6415 26.7752 88.9582 52.5002 88.9582C57.3131 88.9526 62.1024 88.2852 66.7335 86.9748L82.8627 97.2415C83.303 97.524 83.8112 97.6829 84.334 97.7015C84.8568 97.7201 85.375 97.5977 85.8343 97.3472C86.2936 97.0967 86.677 96.7272 86.9445 96.2776C87.2119 95.8279 87.3535 95.3147 87.3543 94.7915V75.1623C91.0038 71.6614 93.916 67.4658 95.9196 62.8224C97.9232 58.1791 98.9777 53.1818 99.021 48.1248C99.1668 25.6082 78.2252 7.2915 52.5002 7.2915ZM75.8335 48.1248C75.8335 48.8984 75.5262 49.6403 74.9792 50.1872C74.4322 50.7342 73.6904 51.0415 72.9168 51.0415H32.0835C31.3099 51.0415 30.5681 50.7342 30.0211 50.1872C29.4741 49.6403 29.1668 48.8984 29.1668 48.1248C29.1668 47.3513 29.4741 46.6094 30.0211 46.0624C30.5681 45.5155 31.3099 45.2082 32.0835 45.2082H72.9168C73.6904 45.2082 74.4322 45.5155 74.9792 46.0624C75.5262 46.6094 75.8335 47.3513 75.8335 48.1248ZM66.3543 62.7082C66.3543 63.4817 66.047 64.2236 65.5001 64.7706C64.9531 65.3175 64.2112 65.6248 63.4377 65.6248H41.5627C40.7891 65.6248 40.0472 65.3175 39.5003 64.7706C38.9533 64.2236 38.646 63.4817 38.646 62.7082C38.646 61.9346 38.9533 61.1928 39.5003 60.6458C40.0472 60.0988 40.7891 59.7915 41.5627 59.7915H63.4377C64.2112 59.7915 64.9531 60.0988 65.5001 60.6458C66.047 61.1928 66.3543 61.9346 66.3543 62.7082ZM29.9835 33.5415C29.9835 32.768 30.2908 32.0261 30.8378 31.4791C31.3848 30.9321 32.1266 30.6248 32.9002 30.6248H72.1002C72.8737 30.6248 73.6156 30.9321 74.1626 31.4791C74.7095 32.0261 75.0168 32.768 75.0168 33.5415C75.0168 34.315 74.7095 35.0569 74.1626 35.6039C73.6156 36.1509 72.8737 36.4582 72.1002 36.4582H32.9002C32.1266 36.4582 31.3848 36.1509 30.8378 35.6039C30.2908 35.0569 29.9835 34.315 29.9835 33.5415Z",
    fill: "#005734"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_454_32",
    x: -10.8332,
    y: -5.2085,
    width: 126.522,
    height: 123.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.203922 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_454_32"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_454_32",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.06a54c44c6dc67e923827707b412c598.svg";
export { ForwardRef as ReactComponent };